<template>
<div class="SceneListContainer">
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <el-input placeholder="请输入部门名称" v-model="queryForm.key"></el-input>
      <button class="primaryBtn" @click="search">搜索</button>
      <div class="query-right">
        <button class="primaryBtn" @click="handleAddClick('add')">新增</button>
      </div>
    </div>
    <div class="tableBox contentShowArea">
      <border-table :loading="DatasLoading" :tableData="DataList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleDataCurrentChange" @sizeChange="handleDataSizeChange">
        <el-table-column prop="deptName" label="部门名称"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>
        <el-table-column prop="deptHeadName" label="部门负责人" sortable="custom"></el-table-column>
        <el-table-column prop="createTime" label="修改时间" sortable="custom"></el-table-column>
        <el-table-column prop="remark" label="备注" sortable="custom"></el-table-column>
        
        <el-table-column fixed="right" label="操作" width="180">
          <template #default="{row}">
            <el-button class="editBtn" type="text" icon="el-icon-edit-outline" @click="handleAddClick('edit', row)">编辑</el-button> 
            <el-button class="delBtn" type="text" icon="el-icon-delete" @click="handleDeleteClick(row.id)" :loading="isDeleting(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </border-table>
    </div>
  </div>

  <el-drawer :title="dataDrawerTitle" size="800px" :modal="false" :visible.sync="dataDrawerShow" @close="handleDrawerClose" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="dataDrawerForm" :model="form" :rules="formRules" label-position="right">
          <el-form-item label="部门名称" prop="deptName" class="name-form">
            <el-input v-model.trim="form.deptName" type="text" :maxlength="30" placeholder="请输入" class="input-name"></el-input>
          </el-form-item>
          <el-form-item label="负 责 人 " prop="deptHeadId" class="name-form">
            <el-select v-model="form.deptHeadId"  @change="handleChangeDeptHead" placeholder="请选择" class="input-name">
              <el-option
                v-for="item in deptHeadOptions"
                :key="item.id"
                :label="item.nickName"
                :value="item.id">
              </el-option>
            </el-select>
            <!-- <el-input v-model.trim="form.deptHead" type="text" :maxlength="30" placeholder="请输入" class="input-name"></el-input> -->
          </el-form-item>
          <el-form-item label="备 注" prop="remark" class="name-form">
            <el-input v-model.trim="form.remark" type="textarea" :rows="4" placeholder="请输入" class="input-name"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="handleAddSave" :loading="dataDrawerSaving">{{ dataDrawerSaving ? '提交中' : '提交' }}</el-button>
        <el-button @click="dataDrawerShow = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
import OneGroupCheckboxs from "@/components/common/OneGroupCheckboxs";
import {
  log
} from 'util';
export default {
  components: {
    BorderTable,
    OneGroupCheckboxs
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableHeight: null,
      DatasLoading: false,
      DataList: [],
      queryForm: {
        key: ''
      },
      form: {
        deptName: '',
        deptHeadId: '',
        remark: '',
      },
      formRules: {
         deptName: [{ required: true, message: "部门名称不能为空", trigger: "blur" }],
         deptHeadId: [{ required: true, message: "负责人不能为空", trigger: "blur" }]
      },
      dataDrawerTitle: '新增',
      type: 'add',
      dataDrawerShow: false,
      dataDrawerSaving: false,
      deptHeadOptions: []
    };
  },
  computed: {
    currentTreeId() {
      return this.$store.state.currentTreeId;
    },
    screenData() {
      return this.$store.state.screen;
    },
    isDeleting() {
      return index => {
        return this[`isDeleting${index}`]
      }
    }
  },
  watch: {
    screenData() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    }
  },
  created() {
    this.makeheight();
  },
  mounted() {
    this.queryDeptHeadOptions();
    this.queryDataList();
  },
  methods: {
    search() {
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    /**
     * @Description 请求负责人
     * @Author      YOYO     -             2022-11-07
     */
    queryDeptHeadOptions() {
      this.request.get("/front/polling/related/getUserListByTenantId")
        .then(rs => {
          if (rs.code == 200) {
            this.deptHeadOptions = rs.data || []
          } else {
            this.deptHeadOptions = []
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    /**
     * @Description 请求数据列表
     * @Author      YOYO     -             2022-11-04
     */
    queryDataList() {
      let { currentPage, pageSize } = this.pagination
      let key = this.queryForm.key
      this.DatasLoading = true;
      let defaults = {
        page: currentPage,
        pageSize,
        key
        // sort: 'createTime',
        // order: 'desc'
      }
      // let params = Object.assign(defaults, this.queryForm)
      this.request.get("/front/polling/related/query", defaults)
        .then(rs => {
          if (rs.code == 200) {
            this.DataList = rs.data || []
            this.pagination.total = rs.total
          } else {}
          this.DatasLoading = false;
        })
        .catch(error => {
          console.error(error);
          this.DatasLoading = false;
        });
    },
    /**
     * @Description 新增or编辑
     * @Author      YOYO     -             2022-11-04
     */    
    handleAddClick(type, data) {
      // console.log(data)
      this.dataDrawerShow = true;
      this.dataDrawerTitle = type == 'add' ? '新增' : '编辑'
      this.type = type

      let form = {
        deptName:'',
        deptHeadId:'',
        deptHeadName: '',
        remark:''
      }

      if (type == 'edit') {
        let { deptName,  deptHeadId, deptHeadName, remark, id } = data
        form = { deptName,  deptHeadId, deptHeadName, remark, id }
      }
      this.form = form
    },
    /**
     * @Description 切换列表页数
     * @Author      YOYO     -             2022-07-05
     */
    handleDataCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.queryDataList();
    },
    /**
     * @Description 切换列表分页大小
     * @Author      YOYO     -             2022-07-05
     */
    handleDataSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.queryDataList();
    },
    handleDrawerClose () {
      this.dataDrawerShow = false
    },
    handleAddSave () {
      this.$refs['dataDrawerForm'].validate((valid) => {
        if (valid) {
          let params = this.form
 
          this.dataDrawerSaving = true

          let url = this.type == 'add' ? '/front/polling/related/add' : '/front/polling/related/updateRelatedDeptById'
          this.request.post(url, params).then(res => {
            this.dataDrawerSaving = false
            let msgText = params.id ? '编辑' : '提交'
            if (res.code === 200) {
              this.dataDrawerShow = false
              this.$message({ type: 'success', message: `${msgText}成功！`})
              this.pagination.currentPage = 1
              this.queryDataList()
            } else {
              this.$message({ type: 'error', message: `${msgText}失败！${res.msg},请重新提交`})
            }
          })
        } else {
          this.$message({ type: 'warning', message: '请按照要求填写正确信息！'})
          return false;
        }
      })
    },
    // 删除列表
    handleDeleteClick (id) {
      this.$confirm('此操作将永久删除该条信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this[`isDeleting${id}`] = true
          this.request.get(`/front/polling/related/delById?id=${id}`).then(res => {
            this[`isDeleting${id}`] = false
            if (res.code === 200) {
              this.$message({ type: 'success', message: '删除成功！'})
              this.pagination.currentPage = 1
              this.queryDataList()
            } else {
              this.$message({ type: 'error', message: '删除失败！请重重试'})
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })         
        })
    },
    handleChangeDeptHead (e) {
      let nickName = this.deptHeadOptions.find(({ id }) => id == e).nickName
      this.form.deptHeadName = nickName
    }
  }
};
</script>

<style lang="scss" scoped>
.SceneListContainer {
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
      .query-right {
        float: right
      }
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.SceneListContainer {
  .drawerWrap {
    border: 1px solid transparent;
    .drawerBody {
      margin-top: 20px;
    }
    .el-form .el-input {
      width: 162px;
    }
    .drawer-title {
      font-size: 16px;
      position: relative;
      margin-bottom: 10px;
      &::before {
        position: absolute;
        content: '';
        height: 12px;
        border-left: 2px solid #2177E6;
        top: 5px;
        left: -10px;
      }
    }
    .el-form-item__label {
      min-width: 90px;
    }
  }
  .drawerWrap .el-form .el-form-item__content .input-name{
    width: 600px;
  }
  // .drawerWrap .el-form .el-form-item__content .el-textarea{
  //   width: 600px;
  // }
  // .drawerWrap .el-form .el-form-item__content .el-input{
  //   width: 600px;
  // }
  .mainContent {
    .query {
      .el-input {
        width: 200px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }

  }

  .formBox {
    .el-form-item {
      display: inline-block;
      margin-right: 10px;
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }
    .name-form {
      display: block;
    }
  }

  .contentShowArea {

    .el-table__fixed-right {
      &::before {
        display: none;
      }

      .el-table__fixed-body-wrapper {
        tbody {
          tr {
            td {
              // border: none;
              // padding: 9px 0;

              .cell {
                text-align: center;

                .editBtn {
                  color: #28c6a2;
                }

                .delBtn {
                  color: #dd3071;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
